/**
 * 전체 이용자 로그 (슈퍼관리자용)
 * 모든 사용자의 USER_ACTIVITY + ADMIN_ACTIVITY를 조회할 수 있습니다.
 */
import ActivityLogs from '@/components/settings/activity-logs/admin';

/**
 * 슈퍼관리자용 전체 이용자 로그 컴포넌트
 * customerId를 null로 전달하여 고객사 선택 UI를 표시하고,
 * logType을 'user_logs'로 설정하여 이용자 활동만 표시합니다.
 */
const ActivityLogsSuperadmin: React.FC = () => {
  return <ActivityLogs customerId={null} logType="user_logs" />;
};

export default ActivityLogsSuperadmin;
